export default "__VITE_ASSET__b543df41__"